import { useState, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';

let resolveCallback = null;

export function ConfirmDialog({ state, onResolve }) {
  if (!state.open) return null;
  return (
    <AnimatePresence>
      {state.open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm px-4"
        >
          <motion.div
            initial={{ scale: 0.85, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.85, opacity: 0, y: 20 }}
            transition={{ type: 'spring', stiffness: 300, damping: 25 }}
            className="bg-white rounded-3xl shadow-2xl max-w-sm w-full p-6 flex flex-col gap-5"
          >
            <div className="flex items-start gap-4">
              <div className="w-11 h-11 rounded-2xl bg-orange-100 flex items-center justify-center shrink-0">
                <AlertTriangle size={22} className="text-orange-500" />
              </div>
              <div>
                <p className="font-black text-slate-900 text-base tracking-tight">{state.title || 'Limited Stock'}</p>
                <p className="text-slate-500 text-sm mt-1 leading-relaxed">{state.message}</p>
              </div>
            </div>
            <div className="flex gap-3">
              <button
                onClick={() => onResolve(false)}
                className="flex-1 py-3 rounded-2xl border-2 border-slate-200 text-slate-600 font-black text-sm uppercase tracking-widest hover:bg-slate-50 transition-all active:scale-95"
              >
                Cancel
              </button>
              <button
                onClick={() => onResolve(true)}
                className="flex-1 py-3 rounded-2xl bg-orange-500 text-white font-black text-sm uppercase tracking-widest hover:bg-orange-600 transition-all active:scale-95 shadow-lg shadow-orange-200"
              >
                Add {state.qty}
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export function useConfirm() {
  const [state, setState] = useState({ open: false, message: '', title: '', qty: '' });

  const confirm = useCallback((message, title, qty) => {
    setState({ open: true, message, title, qty });
    return new Promise((resolve) => {
      resolveCallback = resolve;
    });
  }, []);

  const onResolve = useCallback((result) => {
    setState({ open: false, message: '', title: '', qty: '' });
    if (resolveCallback) resolveCallback(result);
    resolveCallback = null;
  }, []);

  return { state, confirm, onResolve };
}